import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Category } from '@/__generated_graphql__/graphql';
import { Collapse } from '@/components/Collapse/Collapse';
import { SubFooterLink } from '@/components/ui/SubFooterLink/SubFooterLink';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { useNavigate } from '@/hooks/useNavigate';
import { useSearchRoute } from '@/hooks/useSearchRoute';
import { useParticipant } from '@/providers/ParticipantProvider';

import * as S from './SubFooterMobile.styles';

type SubFooterMobileProps = {
  categories: Category[];
};

export const SubFooterMobile: FC<SubFooterMobileProps> = ({ categories }) => {
  const { t } = useTranslation();
  const { participant } = useParticipant();
  const { navigate } = useNavigate();
  const participantLower = participant.toLowerCase();

  const SEARCH = useSearchRoute();

  const categoryItems = useMemo(
    () =>
      categories.map(({ id: categoryId, name: categoryName, children }) => ({
        key: categoryId,
        header: categoryName,
        children: (
          <S.NavigationItemWrapper>
            {children.map(({ name, id }) => {
              const link = navigate({
                link: true,
                route: SEARCH,
                params: { categoryIds: id },
                participant
              }) as string;

              return <SubFooterLink key={id} name={name} path={link} />;
            })}
          </S.NavigationItemWrapper>
        )
      })),
    [categories.length]
  );

  return (
    <div>
      <S.SectionWrapper>
        <Typography variant="h5">
          {t(`SubFooter.title_${participantLower}`)}
        </Typography>
      </S.SectionWrapper>
      <S.Divider />
      <S.SectionWrapper>
        <Collapse items={categoryItems} />
      </S.SectionWrapper>
    </div>
  );
};
